/*
 * @format
 * these are not action creators
 * they are helpers for creating Halo messages for sending via websockets
 */

import { unflattenSchedule } from '../schedule/schedule';

export const hello = () => ({
  action: 'hello',
});

export const publish = (homeId, requestId) => ({
  action: 'publish',
  data: {
    requestId,
    siId: homeId,
  },
});

export const setMode = (
  homeId,
  zoneId,
  requestId,
  mode,
  setpoint,
  holdDuration,
  deviceToken,
) => ({
  action: 'setPrtMode',
  deviceToken,
  data: {
    requestId,
    siId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    mode,
    setpoint,
    holdDuration,
  },
});

export const cancelOverride = (homeId, zoneId, requestId, deviceToken) => ({
  action: 'cancelOverride',
  deviceToken,
  data: {
    requestId,
    siId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
  },
});

export const setPrtSchedule = (
  siId,
  zoneId,
  requestId,
  schedule,
  deviceToken,
) => ({
  action: 'setSchedule',
  deviceToken,
  data: {
    siId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    requestId,
    schedule: unflattenSchedule(schedule),
  },
});

export const setHolidayMode = (
  homeId,
  zoneId,
  requestId,
  endTime,
  deviceToken,
) => ({
  action: 'setHolidayMode',
  deviceToken,
  data: {
    siId: homeId,
    prtId: zoneId,
    requestId,
    endTime,
  },
});

export const cancelHolidayMode = (homeId, zoneId, requestId, deviceToken) => ({
  action: 'cancelHolidayMode',
  deviceToken,
  data: {
    siId: homeId,
    prtId: zoneId,
    requestId,
  },
});

export const setPrtSettings = (
  homeId,
  zoneId,
  configName,
  configValue,
  requestId,
  deviceToken,
) => ({
  action: 'setPrtSettings',
  deviceToken,
  data: {
    siId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    configName,
    configValue,
    requestId,
  },
});

export const hpiSetPrtSettings = (
  homeId,
  zoneId,
  configName,
  configValue,
  requestId,
  deviceToken,
) => ({
  action: 'hpiSetPrtSettings',
  deviceToken,
  data: {
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    configName,
    configValue,
    requestId,
  },
});

export const unpairDevice = (homeId, prtId, requestId, deviceToken) => ({
  action: 'unpairDevice',
  deviceToken,
  data: {
    siId: homeId,
    prtId,
    requestId,
  },
});

export const setPRTCustomProperties = (homeId, zoneId, newName, requestId) => ({
  action: 'setPrtCustomProperties',
  data: {
    requestId,
    siId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    properties: {
      FriendlyName: newName,
    },
  },
});

export const setChildLock = (
  homeId,
  zoneId,
  lockOn,
  requestId,
  deviceToken,
) => ({
  action: 'setChildLock',
  deviceToken,
  data: {
    requestId,
    siId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    lockOn,
  },
});

export const setIdentifyMode = (homeId, zoneId, enabled, requestId) => ({
  action: 'setIdentifyMode',
  data: {
    requestId,
    siId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    enabled,
  },
});

export const getPrtMessage = (
  homeId,
  zoneId,
  requestId,
  prtSetting,
  value,
  deviceToken,
) => {
  let enabledState = value;
  if (typeof value === 'boolean') {
    enabledState = value ? '1' : '0';
  } else if (typeof value === 'number') {
    enabledState = value.toString();
  }

  switch (prtSetting) {
    case 'setChildLock':
      return setChildLock(homeId, zoneId, value, requestId, deviceToken);
    case 'setIdentifyMode':
      return setIdentifyMode(homeId, zoneId, value, requestId, deviceToken);
    case 'setZoneName':
      return setZoneName(homeId, zoneId, value, requestId, deviceToken);
    case 'setCustomPrtProperty':
      return setPRTCustomProperties(homeId, zoneId, value, requestId);
    case 'unpairDevice':
      return unpairDevice(homeId, zoneId, requestId, deviceToken);

    default:
      return setPrtSettings(
        homeId,
        zoneId,
        prtSetting,
        enabledState,
        requestId,
        deviceToken,
      );
  }
};

export const hpiSetIdentifyMode = (homeId, zoneId, enabled, requestId) => ({
  action: 'hpiSetIdentifyMode',
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    enabled,
  },
});

export const hpiSetChildLock = (
  homeId,
  zoneId,
  lockOn,
  requestId,
  deviceToken,
) => ({
  action: 'hpiSetChildLock',
  deviceToken,
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    lockOn,
  },
});

export const hpiSetZoneName = (homeId, zoneId, text, requestId) => ({
  action: 'hpiSetZoneName',
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    text,
  },
});

export const hpiTimedDhw = (homeId, zoneId, enabled, requestId) => ({
  action: 'hpiTimedDhw',
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    enabled,
  },
});

export const hpiSetDhwEmergencyOperation = (
  homeId,
  zoneId,
  emergencyOperation,
  requestId,
) => ({
  action: 'hpiSetDhwEmergencyOperation',
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    emergencyOperation,
  },
});

export const hpiUnpairDevice = (homeId, deviceId, requestId, deviceToken) => ({
  action: 'hpiUnpairDevice',
  deviceToken,
  data: {
    requestId,
    hpiId: homeId,
    prtId: deviceId,
  },
});

export const hpiGetPrtMessage = (
  homeId,
  zoneId,
  requestId,
  prtSetting,
  value,
  deviceToken,
) => {
  let configValue = value;
  if (typeof value === 'boolean') {
    configValue = value ? '1' : '0';
  } else if (typeof value === 'number') {
    configValue = value.toString();
  }

  switch (prtSetting) {
    case 'hpiSetChildLock':
      return hpiSetChildLock(homeId, zoneId, value, requestId, deviceToken);
    case 'hpiSetIdentifyMode':
      return hpiSetIdentifyMode(homeId, zoneId, value, requestId, deviceToken);
    case 'hpiSetZoneName':
      return hpiSetZoneName(homeId, zoneId, value, requestId, deviceToken);
    case 'hpiTimedDhw':
      return hpiTimedDhw(homeId, zoneId, value, requestId, deviceToken);
    case 'hpiSetDhwEmergencyOperation':
      return hpiSetDhwEmergencyOperation(homeId, zoneId, value, requestId);
    case 'hpiSetPrtComfortTemperature':
      return hpiSetPrtComfortTemperature(
        homeId,
        zoneId,
        configValue,
        requestId,
        deviceToken,
      );
    case 'hpiSetPrtReducedTemperature':
      return hpiSetPrtReducedTemperature(
        homeId,
        zoneId,
        configValue,
        requestId,
        deviceToken,
      );

    default:
      return hpiSetPrtSettings(
        homeId,
        zoneId,
        prtSetting,
        configValue,
        requestId,
        deviceToken,
      );
  }
};

export function setHeatCurveValue(homeId, { curve, nominalTemp }, requestId) {
  return {
    action: 'setHeatCurveValue',
    data: {
      requestId,
      siId: homeId,
      curve,
      nominalTemp,
    },
  };
}


export const setZoneName = (siId, zoneId, text, requestId) => ({
  action: 'setZoneName',
  data: {
    requestId,
    siId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    text,
  },
});

// HPI messages
export const hpiPublish = (homeId, requestId) => ({
  action: 'hpiPublish',
  data: {
    requestId,
    hpiId: homeId,
  },
});

export const hpiSetMode = (
  homeId,
  zoneId,
  requestId,
  mode,
  setpoint,
  holdDuration,
  deviceToken,
) => ({
  action: 'hpiSetPrtMode',
  deviceToken,
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    mode,
    setpoint,
    holdDuration,
  },
});

export const hpiCancelOverride = (homeId, zoneId, requestId, deviceToken) => ({
  action: 'hpiCancelOverride',
  deviceToken,
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
  },
});

export const hpiSetPrtSchedule = (
  hpiId,
  zoneId,
  requestId,
  schedule,
  deviceToken,
) => ({
  action: 'hpiSetSchedule',
  deviceToken,
  data: {
    hpiId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    requestId,
    schedule: unflattenSchedule(schedule),
  },
});

export const hpiSetHolidayMode = (
  homeId,
  zoneId,
  requestId,
  endTime,
  deviceToken,
) => ({
  action: 'hpiSetHolidayMode',
  deviceToken,
  data: {
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    requestId,
    endTime,
  },
});

export const hpiCancelHolidayMode = (
  homeId,
  zoneId,
  requestId,
  deviceToken,
) => ({
  action: 'hpiCancelHolidayMode',
  deviceToken,
  data: {
    hpiId: homeId,
    prtId: zoneId,
    requestId,
  },
});

export const hpiSetPrtComfortTemperature = (
  homeId,
  zoneId,
  setpoint,
  requestId,
  deviceToken,
) => ({
  action: 'hpiSetPrtComfortTemperature',
  deviceToken,
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    setpoint,
  },
});

export const hpiSetPrtReducedTemperature = (
  homeId,
  zoneId,
  setpoint,
  requestId,
  deviceToken,
) => ({
  action: 'hpiSetPrtReducedTemperature',
  deviceToken,
  data: {
    requestId,
    hpiId: homeId,
    prtId: zoneId[0],
    endpointId: zoneId[1],
    setpoint,
  },
});

export const liveDataSubscribe = (homeId, requestId) => ({
  action: 'hpiLiveDataSubscribe',
  data: {
    requestId,
    hpiId: homeId,
  },
});

export const liveDataUnsubscribe = (homeId, requestId, connectionId) => ({
  action: 'hpiLiveDataUnsubscribe',
  data: {
    requestId,
    hpiId: homeId,
    connectionId,
  },
});

export function getInterfaceSettingMessage(
  homeId,
  requestId,
  settingName,
  value,
) {
  switch (settingName) {
    case 'setHeatCurveValue': {
      return setHeatCurveValue(homeId, value, requestId);
    }
    case 'unpairDevice': {
      return unpairDevice(homeId, value, requestId);
    }
    case 'hpiUnpairDevice':
      return hpiUnpairDevice(homeId, value, requestId);
  }
}
